// @flow
const GTM_KEY = 'GTM-P95PGRD';

// TODO (nkohari): This code is just the recommended blob from Google, but it's
// obviously hideous. We should rewrite this to be something human-readable.
export function initializeGoogleTagManager() {
  /* eslint-disable */
  const nonce = window.__CSP_NONCE__ || '';
  (function(w, d, s, l, i) {
    w[l] = w[l] || [];
    w[l].push({
      'gtm.start': new Date().getTime(),
      event: 'gtm.js',
    });
    var f = d.getElementsByTagName(s)[0],
      j = d.createElement(s),
      dl = l != 'dataLayer' ? '&l=' + l : '';
    j.async = true;
    j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
    j.setAttribute('nonce', nonce);
    if (f && f.parentNode) {
      f.parentNode.insertBefore(j, f);
    }
  })(window, document, 'script', 'dataLayer', GTM_KEY);
  /* eslint-enable */
}
